/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Point_2_TextInputs */

const en_visa_eb5_point_2_text = /** @type {(inputs: Visa_Eb5_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment amounts and program rules can change, so we evaluate each matter against the requirements in effect at the time of filing.`)
};

const pt_visa_eb5_point_2_text = /** @type {(inputs: Visa_Eb5_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os valores de investimento e as regras do programa podem mudar, portanto, avaliamos cada caso em relação aos requisitos em vigor no momento da apresentação.`)
};

const es_visa_eb5_point_2_text = /** @type {(inputs: Visa_Eb5_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los montos de inversión y las reglas del programa pueden cambiar, por lo que evaluamos cada caso según los requisitos vigentes al momento de la presentación.`)
};

/**
* | output |
* | --- |
* | "Investment amounts and program rules can change, so we evaluate each matter against the requirements in effect at the time of filing." |
*
* @param {Visa_Eb5_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_point_2_text = /** @type {((inputs?: Visa_Eb5_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_point_2_text(inputs)
	if (locale === "es") return es_visa_eb5_point_2_text(inputs)
	return en_visa_eb5_point_2_text(inputs)
});